import { useFormContext } from '@american-autonomy/ag-ui';

import FormGrid from 'components/FormGrid';
import ClientNameField from 'components/fields/ClientNameField';
import ContactNameField from 'components/fields/ContactNameField';
import EmailAddressField from 'components/fields/EmailAddressField';
import PhoneNumberField from 'components/fields/PhoneNumberField';

import useTranslation from './hooks/useTranslation';

import {
    CLIENT_NAME_FIELD_NAME,
    CONTACT_NAME_FIELD_NAME,
    EMAIL_FIELD_NAME,
    PHONE_NUMBER_FIELD_NAME,
    TEST_ID
} from './constants';
import type { ClientFormSchema, FieldPath, Props } from './types';

const ClientFormFields = <T extends ClientFormSchema>({
    children,
    namePrefix,
    testId = TEST_ID
}: Props<T>) => {
    const { control } = useFormContext<T>();
    const {
        CLIENT_NAME_FIELD_PLACEHOLDER,
        CONTACT_NAME_FIELD_PLACEHOLDER,
        EMAIL_FIELD_PLACEHOLDER,
        PHONE_NUMBER_FIELD_PLACEHOLDER
    } = useTranslation();

    const fieldName = (name: keyof ClientFormSchema) =>
        (namePrefix ? `${namePrefix}.${name}` : String(name)) as FieldPath<T>;

    return (
        <FormGrid testId={testId}>
            <ClientNameField<T>
                control={control}
                isRequired={true}
                name={fieldName(CLIENT_NAME_FIELD_NAME)}
                placeholder={CLIENT_NAME_FIELD_PLACEHOLDER}
            />

            <ContactNameField<T>
                control={control}
                name={fieldName(CONTACT_NAME_FIELD_NAME)}
                placeholder={CONTACT_NAME_FIELD_PLACEHOLDER}
            />

            <EmailAddressField<T>
                control={control}
                name={fieldName(EMAIL_FIELD_NAME)}
                placeholder={EMAIL_FIELD_PLACEHOLDER}
            />

            <PhoneNumberField<T>
                control={control}
                name={fieldName(PHONE_NUMBER_FIELD_NAME)}
                placeholder={PHONE_NUMBER_FIELD_PLACEHOLDER}
            />

            {children}
        </FormGrid>
    );
};

export default ClientFormFields;
